export const FILTERS_ORDER_SETTINGS_KEY_VERSION_EXAMPLES = "version-examples";

export const NO_STICKY_RIGHT = () => false;
